import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import styled from 'src/Theme/styled';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Image from 'next/image';
import { useTheme } from '@mui/material/styles';
export interface MediaCardProps {
  title: string;
  media?: {
    alternativeText?: string | null;
    thumbnailUrl?: string | null;
  } | null;
  onClick?: () => void;
}
const Container = styled(Card)(({
  theme
}) => ({
  width: '100%',
  backgroundColor: theme.colors.surface.primary,
  borderRadius: theme.sizes.radius.xl,
  boxShadow: theme.boxShadows[2],
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  cursor: 'pointer'
}));
const ContentArrow = styled(FlexColumn)(({
  theme
}) => ({
  padding: `0 ${theme.sizes.spacing['04']}`,
  alignItems: 'center',
  justifyContent: 'center',
  borderLeft: `1px solid ${theme.colors.border.primary}`,
  height: '100%'
}));
const MainContent = styled(FlexRow)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%'
}));
export const MediaCard: React.FC<MediaCardProps> = t0 => {
  const $ = _c(13);
  const {
    title,
    media,
    onClick
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== media || $[1] !== theme || $[2] !== title) {
    t1 = media?.thumbnailUrl && <FlexColumn sx={{
      position: "relative",
      width: "100%",
      aspectRatio: "16 / 9"
    }}><Image src={media.thumbnailUrl} alt={media?.alternativeText || title} fill={true} style={{
        objectFit: "cover"
      }} sizes={`(max-width: ${theme.breakpoints.values.md}px) 100vw, (max-width: ${theme.breakpoints.values.lg}px) 50vw, 33vw`} /></FlexColumn>;
    $[0] = media;
    $[1] = theme;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== title) {
    t2 = <Typography variant="heading-md" sx={_temp}>{title}</Typography>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ContentArrow><ChevronRightIcon /></ContentArrow>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <MainContent>{t2}{t3}</MainContent>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClick || $[10] !== t1 || $[11] !== t4) {
    t5 = <Container onClick={onClick}>{t1}{t4}</Container>;
    $[9] = onClick;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default MediaCard;
function _temp(theme_0) {
  return {
    color: theme_0.colors.text.primary,
    padding: theme_0.sizes.spacing["08"]
  };
}